import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { customizeTheme } from './config/style/theme';

export const UIProvider = ({
  children,
  fontSizes,
  globalStyle = {},
  themeConfig = {},
  ...providerProps
}) => {
  const theme = customizeTheme({ globalStyle, themeConfig });

  return (
    <ChakraProvider theme={theme} {...providerProps}>
      {children}
    </ChakraProvider>
  );
};

// export default fonts
export { default as Fonts } from './fonts/Fonts';

// export custom components
export * from './components';

// export custom hooks
export * from './hooks';
